export default __webpack_public_path__ + "static/media/jekyll.e17e31da.svg";